<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p>{{ $t('onboarding.nestle.paperworkHome.title') }}</p>
      </div>
      <div class="body">
        <div class="description">
            <p>{{ $t('onboarding.nestle.paperworkHome.introduction') }}</p>
        </div>
        <img class="nav-img" :src="firstImgUrl" alt="">
        <div class="text-board">
          <p class="board-subtitle">{{ $t('onboarding.nestle.paperworkHome.firstSubIntroduction') }}</p>
          <br/>
          <p class="board-subtitle">{{ $t('onboarding.nestle.paperworkHome.secondSubIntroduction') }}</p>
        </div>
        <div class="text-board">
          <div class="board-title">
            <div class="step-out-circle"><div class="step-in-circle"><span>{{ $t('onboarding.nestle.paperworkHome.step') }}</span><span>1</span></div></div>
            <div class="step-title">{{ $t('onboarding.nestle.paperworkHome.firstStepTitle') }}</div>
          </div>
          <p class="board-subtitle">{{ $t('onboarding.nestle.paperworkHome.firstStepIntroduction1') }}</p>
          <br/>
          <p class="board-subtitle" v-html="$t('onboarding.nestle.paperworkHome.firstStepIntroduction2')"></p>
          <br/>
          <p class="board-subtitle" v-html="$t('onboarding.nestle.paperworkHome.firstStepIntroduction3')"></p>
        </div>
        <div class="text-board">
          <div class="board-title">
            <div class="step-out-circle"><div class="step-in-circle"><span>{{ $t('onboarding.nestle.paperworkHome.step') }}</span><span>2</span></div></div>
            <div class="step-title">{{ $t('onboarding.nestle.paperworkHome.secondStepTitle') }}</div>
          </div>
          <p class="board-subtitle" v-html="$t('onboarding.nestle.paperworkHome.secondStepIntroduction1')"></p>
        </div>
        <div class="text-board">
          <div class="board-title">
            <div class="step-out-circle"><div class="step-in-circle"><span>{{ $t('onboarding.nestle.paperworkHome.step') }}</span><span>3</span></div></div>
            <div class="step-title">{{ $t('onboarding.nestle.paperworkHome.thirdStepTitle') }}</div>
          </div>
          <p class="board-subtitle">{{ $t('onboarding.nestle.paperworkHome.thirdStepIntroduction1') }}</p>
          <br/>
          <p class="board-subtitle" v-html="$t('onboarding.nestle.paperworkHome.thirdStepIntroduction2')"></p>
        </div>
        <div class="dividing-line"></div>
        <div class="text-board">
          <p class="board-title">{{ $t('onboarding.nestle.paperworkHome.contact') }}<a href=mailto:ESNBSChina@cn.nestle.com>ESNBSChina@cn.nestle.com</a></p>
          <div class="start-btn" @click="toNext">
            <button :style="goBtnStyle">{{ startText }}</button>
            <button class="jump" :style="goBtnStyle"><img src="@/assets/image/onboarding/common/arrow-right-white.png" alt=""></button>
          </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      firstImgUrl: require(isMobile ? '@/assets/image/onboarding/paperwork/h5/nav.jpg' : '@/assets/image/onboarding/paperwork/pc/nav.png'),
      isFinished: false
    }
  },
  computed: {
    startText () {
      return this.isFinished ? this.$t('onboarding.nestle.paperworkHome.finished') : this.$t('onboarding.nestle.paperworkHome.start')
    },
    goBtnStyle () {
      return this.isFinished ? 'background-color: gray;' : 'background-color: #00539F;'
    }
  },
  async created () {
    await this.$parent.refreshInvitationInfo()
    const invitationInfo = this.$parent.invitationInfo
    if (invitationInfo) {
      this.isFinished = invitationInfo.is_finished
    }
  },
  methods: {
    toNext () {
      if (this.isFinished) {
        return
      }
      const questionnaireId = this.$parent.invitationInfo.questionnaire_id
      this.toVuePage({ path: `/onboarding/${this.invitationId}/nestle/paperwork/${questionnaireId}` })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';
@import '~@/assets/iconfont/iconfont.css';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/paperwork/h5/banner.jpg');
  }
  .body {
    background-color: #FFF;
    .nav-img {
      width: 85%;
      margin: 2rem 0;
    }
    .text-board {
      .board-title {
        font-size: 1.5rem;
        text-align: center;
        display: flex;
        align-items: center;
        margin-bottom: 35px;
        .step-out-circle {
          z-index: 101;
          width: 70px;
          height: 70px;
          border-radius: 35px;
          background-color: gray;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          .step-in-circle {
            @extend .step-out-circle;
            width: 60px;
            height: 60px;
            border-radius: 30px;
            font-size: large;
            border: solid 1px white;
            color: white;
          }
        }
        .step-title {
          background-color: gray;
          color: white;
          width: 220px;
          height: 40px;
          font-size: large;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          position: relative;
          left: -10px;
          z-index: 100;
        }
      }
      .board-subtitle {
        font-size: 1.3rem;
        text-align: left;
        width: 100%;
      }
    }
    .start-btn {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: center;
      button {
        color: #FFF;
        border: none;
        padding: 0.5rem;
        font-size: 1.4rem;
      }
      .jump {
        margin-left: 0.5rem;
        font-size: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/paperwork/pc/banner.jpg');
      height: 20rem;
    }
    .body {
      .description {
        font-size: 1.3rem;
      }
      .text-board {
        .board-title {
          font-size: xx-large;
          .step-out-circle {
            width: 100px;
            height: 100px;
            border-radius: 50px;
            .step-in-circle {
              width: 90px;
              height: 90px;
              border-radius: 45px;
              font-size: x-large;
            }
          }
          .step-title {
            width: 400px;
            height: 50px;
            font-size: x-large;
          }
        }
        .board-subtitle {
          font-size: 1rem;
          color: #595859;
        }
      }
      .start-btn {
        height: 80px;
        button {
          font-size: x-large;
        }
      }
    }
  }
}
</style>
